module.exports = __webpack_public_path__ + "static/media/coupon-express.b7e5eb30.svg";